<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" :color="color" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.76103 10.0287L12.2821 3.30385C12.6666 2.90737 13.2997 2.89763 13.6962 3.2821C14.0926 3.66657 14.1024 4.29966 13.7179 4.69615L5.69354 12.9713L2.25095 9.07889C1.88506 8.66519 1.92382 8.03321 2.33751 7.66733C2.75121 7.30144 3.38318 7.34019 3.74907 7.75389L5.76103 10.0287Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'TickIcon',
  props: {
    width: {
      type: Number,
      default: 16,
    },
    height: {
      type: Number,
      default: 16,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
